module.exports = __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu7GxKKTU1Kvnz.b4c84cf6.woff2";